
export class EventSystemNames {
    static readonly onFeatureMouseOver = "onFeatureMouseOver";
    static readonly onFeatureMouseOut = "onFeatureMouseOut";
    static readonly onFeatureUnselect = "onFeatureUnselect";
    static readonly PilotCoastalSegmentGroup = "PilotCoastalSegmentGroup";
    static readonly PilotCertificateCoastalSegment = "PilotCertificateCoastalSegment";
    static readonly MapTitle = "MapTitle";
    static readonly PilotCertificateCoastalSegmentGroups = "PilotCertificateCoastalSegmentGroups";
}
